<template>
	<div class="sites-dashboard">
<!--		<UserMenu />-->
		<div class="main-panel w-100">
			<TopNav :inCollaborator="true" />
			<Outages />
			<router-view></router-view>
		</div>
	</div>
</template>

<script>
export default {
  name: "layout",
  components: {
    UserMenu: () =>
      import(/* webpackChunkName: "userMenu" */ "../components/User/SideMenu.vue"),
    TopNav: () =>
      import(/* webpackChunkName: "topNav" */ "../components/TopNav.vue"),
	Outages: () =>
		import(/* webpackChunkName: "supportTicketsList" */ "../components/Helps/OutageBanner.vue"),

  },
};
</script>
<style scoped type="scss">
	.w-100 {
		width: 100% !important;
	}
</style>
